import router from "@/router";

export default {
  name: "g-menu-item",
  props:{
    titulo: {
      type: String,
      default: ''
    },
    idItem: {
      type: String,
      default: ''
    },
    subItens: {
      type: Array,
      default: []
    },
    ehSubItem: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    if (this.subItens.length > 0) {
      this.expansivel = true
    }
    this.ativo = this.idItem.includes(this.$route.path.replace('/',''))
    
  },
  data() {
    return {
      expansivel: false,
      ativo: false,
    };
  },
  methods: {
    toggleAccordion() {
      if (!this.expansivel) {
        this.$emit('acao')
        router.push(`/${this.idItem}`)
      }
      this.ativo = !this.ativo;
    },
  },
  
  computed: {
    margem (){
      return this.ehSubItem ? '25px':'15px'
    },
    fontSize() {
      return this.ehSubItem ? '16px':'20px'
    },
    corTitulo () {
      return this.ativo ? '#4f2c19': '#8a8a8a'
    },
    weightTitulo () {
      return this.ativo ? 'bold': 'normal'
    },
    larguraIndicador () {
      return this.ativo ? '3px': ''
    },
    alturaIndicador () {
      return this.ativo ? '100%': ''
    },
    corIndicador () {
      return this.ativo ? '#fcb315': 'none'
    }
  }
  
};
